export default [
  {
    path: '/admin/deleted-items/lists',
    name: 'deleted-items-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mart-sale/deleted-items-list.vue')
  },
]
